"use strict";
/**
 * AngularJS laod indicator component controller.
 *
 * @packageDocumentation
 * @module LoadIndicator
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#endregion
var base_1 = require("../base");
var IMRLoadingContainerController = /** @class */ (function (_super) {
    tslib_1.__extends(IMRLoadingContainerController, _super);
    //#endregion
    //#region Ctor
    function IMRLoadingContainerController($transclude) {
        var _this = _super.call(this) || this;
        _this.$transclude = $transclude;
        //#region Members
        _this.showLoadIndicator = false;
        _this.isContentSlotFilled = false;
        _this.isLoadingContentSlotFilled = false;
        _this.isTransparent = false;
        //#endregion
        //#region Load Indicator
        _this.loadIndicatorOptions = null;
        return _this;
    }
    //#endregion
    //#region Lifecycle
    IMRLoadingContainerController.prototype.initialize = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                this.isTransparent = (_a = this.options.isTransparent) !== null && _a !== void 0 ? _a : false;
                if (!this.isLoadIndicatorInitialized()) {
                    this.initializeTransclusionSlots();
                    this.initializeLoadIndicator();
                }
                return [2 /*return*/];
            });
        });
    };
    IMRLoadingContainerController.prototype.bindingChanged = function (changes) {
        if (changes.isLoading != null && changes.isLoading.currentValue != null) {
            this.showLoadIndicator = changes['isLoading'].currentValue;
        }
        if (!this.isLoadIndicatorInitialized()) {
            this.initializeTransclusionSlots();
            this.initializeLoadIndicator();
        }
    };
    //#endregion
    //#region Component
    IMRLoadingContainerController.prototype.initializeTransclusionSlots = function () {
        this.isContentSlotFilled = this.$transclude.isSlotFilled('content');
        this.isLoadingContentSlotFilled = this.$transclude.isSlotFilled('loading-content');
    };
    IMRLoadingContainerController.prototype.initializeLoadIndicator = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.prepareLoadIndicatorOptions();
                        return [4 /*yield*/, this.waitForLoadIndicatorInitialized()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IMRLoadingContainerController.prototype.isLoadIndicatorInitialized = function () {
        return this.loadIndicatorOptions != null;
    };
    IMRLoadingContainerController.prototype.prepareLoadIndicatorOptions = function () {
        this.loadIndicatorOptions = {
            height: 40,
            width: 40
        };
    };
    IMRLoadingContainerController.prototype.waitForLoadIndicatorInitialized = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.loadIndicatorOptions != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.waitForOnInitialized(this.loadIndicatorOptions)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return IMRLoadingContainerController;
}(base_1.IMRBaseComponentController));
exports.IMRLoadingContainerController = IMRLoadingContainerController;
//# sourceMappingURL=loading-container.controller.js.map